import ClientLayout from "../../layouts/ClientLayout";
import { useEffect, useState } from "react";
import API from "../../services/api";

export default function ViewProgress() {

    const [progressData, setProgressData] = useState([]);

    useEffect(() => {
        loadProgress();
    }, []);


    const loadProgress = async () => {
        try {
            
            const projectId = localStorage.getItem("project_id");
            console.log("LOCAL STORAGE PROJECT =", localStorage.getItem("project_id"));

            const res = await API.get("/admin/schedules");

            const filtered = (res.data.schedules || []).filter(
                (item) => item.project_id == projectId
            );

            console.log("PROGRESS DATA =", filtered);

            setProgressData(filtered);
        } catch (err) {
            console.error(err);
        }
    };

    return (
       <ClientLayout>
            <style>{`@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800;900&display=swap'); .vp-root, .vp-root * { font-family: 'Montserrat', sans-serif !important; }`}</style>
            <div className="vp-root p-6">
                <h1 className="text-2xl font-bold mb-6">
                    View Progress
                </h1>


                {progressData.length === 0 && (
                    <div className="bg-white rounded-xl p-8 text-center border">
                        <h3 className="text-lg font-semibold text-gray-700">
                            No Progress Found
                        </h3>
                        <p className="text-gray-500 mt-2">
                            No before/after photos uploaded yet.
                        </p>
                    </div>
                )}

                <div className="space-y-6">
                    {progressData.map((item, index) => (
                        <div
                            key={index}
                            className="bg-white rounded-xl shadow p-5 border"
                        >
                            <div
                                style={{
                                    background: "#F3EBF8",
                                    padding: "12px 16px",
                                    borderRadius: "10px",
                                    marginBottom: "16px",
                                    borderLeft: "4px solid #6D2B8E",
                                }}
                            >
                                <h2
                                    style={{
                                        margin: 0,
                                        fontSize: "18px",
                                        fontWeight: "700",
                                        color: "#6D2B8E",
                                    }}
                                >
                                    📌 Phase: {item.phase_id}
                                </h2>
                            </div>

                            <div className="grid grid-cols-2 gap-6">
                                <div>
                                    <h3 className="font-medium mb-2">
                                        Before
                                    </h3>
                                    <img
                                        src={`https://totalassureplus.com/api/uploads/${item.before_photo}`}
                                        alt="Before"
                                        className="w-full h-64 object-cover rounded-lg"
                                    />
                                </div>

                                <div>
                                    <h3 className="font-medium mb-2">
                                        After
                                    </h3>
                                    <img
                                        src={`https://totalassureplus.com/api/uploads/${item.after_photo}`}
                                        alt="After"
                                        className="w-full h-64 object-cover rounded-lg"
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </ClientLayout>
    );
}